import React, { useEffect, useState } from 'react';
import {
    getBackgroundImg,
    getUploadedImagePath,
    useAppDispatch,
    useAppState, useBreakpoints
} from '@nutastic/nutastic-react-app';
import TabSlider, { TabSliderContent } from '../../refactor/tabs/TabSlider';
import VideoPlayer from '../../refactor/nu-streamer/components/VideoPlayer';
import { useParams } from 'react-router-dom';
import { useNuStationData } from '../../hooks/useNuStationData';
import { WebsiteActions } from '../../state/actions.mjs';
import ContentNotFoundPage from './ContentNotFoundPage';
import { ContentDescription } from '../ContentDetails';
import { RelatedContentTab } from '../ContentRelations';
import useWindowSize from '../../hooks/useWindowSize';

const componentClass = 'contentPage';

const ContentVideoPage = () => {
    const appDispatch = useAppDispatch();
    const { isProcessing, authState } = useAppState();
    const { getVideoBySlug, getRecentVideoData, videoLibrary } = useNuStationData();
    const [activeTab, setActiveTab] = useState(0);
    const [currentVideo, setCurrentVideo] = useState(null);
    const { id: contentId } = useParams();
    const { xl: isXtraLargeScreen } = useBreakpoints();
    const { windowWidth } = useWindowSize();
    const { isSubscribed } = authState;

    const videoWidth = isXtraLargeScreen ? 1280 : windowWidth;
    const videoHeight = isXtraLargeScreen ? 720 : (videoWidth / (16/9));

    const {
        id: videoId,
        image: videoImage,
        title: videoTitle,
        excerpt: shortDescription,
        field_2: description,
        relatedArtists,
        relatedMusic,
        relatedVideos
    } = currentVideo || {};

    const recentVideoData = getRecentVideoData(videoId);
    const requiresSubscription = (videoLibrary || []).find(v => v.id === videoId)?.requiresSubscription || false;

    useEffect(() => {
        setCurrentVideo(null);
        appDispatch({ type: WebsiteActions.LOADING_PAGE_START });
        const fetchVideoData = async () => {
            try {
                const videoProject = getVideoBySlug(contentId);
                setActiveTab(0);
                setCurrentVideo(videoProject);
            } catch (e) {
                console.log('Failed to fetch video', e);
            }
            setTimeout(() => {
                appDispatch({ type: WebsiteActions.LOADING_PAGE_DONE });
            }, 1000);
        }
        fetchVideoData();
    }, [contentId]);

    const tabs = currentVideo ? [
        { label: 'Details', key: 0, children: <ContentDescription description={description || 'No Description'} /> },
        { label: 'Related', key: 1, children: <RelatedContentTab artists={relatedArtists} music={relatedMusic} videos={relatedVideos} /> },
    ] : [ { key: 0, label: 'Loading', children: '...'} ];

    const subscriptionScreen = <div className={`${componentClass}__subscriptionVideoMessage`} style={{height: videoHeight, width: videoWidth}} onClick={() => appDispatch({ type: WebsiteActions.ACCOUNT_MODAL_SHOW })}>
        <div style={getBackgroundImg(getUploadedImagePath(videoImage))}/>
        <i className="fa fa-lock" />
        <span>Members Only! This video requires a subscription.</span>
    </div>;

    return (!!currentVideo && !isProcessing) ? <article className={componentClass}>
        <div className={`${componentClass}__header videoLayout`}>
            <div className={`${componentClass}__headerInfo videoLayout`}>
                <h1>{ videoTitle }</h1>
                { shortDescription && <p>{ shortDescription }</p> }
            </div>
            { (!requiresSubscription || isSubscribed) ?
                <VideoPlayer
                    videoId={ videoId }
                    videoConfig={ currentVideo }
                    videoSrc={ currentVideo?.content }
                    image={ videoImage }
                    startTime={parseInt(recentVideoData || 0)}
                /> :
                subscriptionScreen
            }
        </div>
        <div className={`${componentClass}__tabs`}>
            <TabSlider tabs={tabs} onChange={setActiveTab} activeKey={activeTab} />
            <div className="container">
                <TabSliderContent tabs={tabs} activeKey={activeTab} />
            </div>
        </div>
    </article> : <ContentNotFoundPage isProcessing={isProcessing} />;
};

export default ContentVideoPage;
